import { Injectable, TRANSLATIONS_FORMAT } from '@angular/core';
import moment from 'moment';
import { Http } from '@angular/http';
import { ToastController } from 'ionic-angular';
import {  ModalController } from 'ionic-angular';
import { GenericModalPage } from '../pages/generic-modal/generic-modal';

@Injectable()
export class CommonData {
  wifierror : string = '';
  staging   : string = 'staging'; //for production leave empty, for staging > staging
  portalurl : string = 'https://portal'+this.staging+'.parkix.ch/';
  checkurl  : string = 'https://check'+this.staging+'.parkix.ch/';
  baseurl   : string = 'https://portal'+this.staging+'.parkix.ch/app.php/';
  filesurl  : string = 'https://files2'+this.staging+'.parkix.ch/'
  loginurl  : string = 'https://portal'+this.staging+'.parkix.ch/login.php';

  pbappurl  : string = 'https://app'+this.staging+'.parkbewilligung.ch';
  

  ubsurl: string = 'https://ubs'+this.staging+'.parkix.ch/';

  golink: string = "https://go"+this.staging+".parkbewilligung.ch/"

  baseurlbeweisbilder = this.portalurl+'beweisbilder/';
  public minDateToday;
  public maxDate;

  actpageviewmode: string = "";
  tmp: string = "";
  constructor(public http: Http, public toastCtrl: ToastController, public modalCtrl: ModalController,) {
    this.minDateToday = moment.utc().startOf('day').format('YYYY-MM-DD');
    this.maxDate = moment.utc().add(3, 'y').format('YYYY-MM-DD');
  }

  public showWifiError(){
      let toast = this.toastCtrl.create({
        message: 'Keine Datenverbindung, es kann keine UE erfasst werden.',
        dismissOnPageChange: true,
        duration: 3000,
        position: 'middle',
        cssClass: 'warning',
        //closeButtonText: 'schliessen',
        //showCloseButton: true
      });
      toast.present();       
  }

public getDistanceFromLatLonInKM(lat1,lon1,lat2,lon2) {
  var R = 6371; // Radius of the earth in m
  var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
  var dLon = this.deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in m
  return d;
}

public deg2rad(deg) {
  return deg * (Math.PI/180)
}  

public random(len) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < len; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

public exiftoiso(strExifDate)
{
  //ist "DateTimeOriginal":"2018:04:26 18:01:03",
  //soll: 2018-04-27T08:50:38+02:00
  let arrExif = strExifDate.split(":");
  return arrExif[0] + "-" + arrExif[1] + "-" + arrExif[2].replace(" ", "T")+":" + arrExif[3]+":"+arrExif[4];

}

boolToText(value){
  if(value == 0){
    return "nein";
  }
  else{
    return "ja";
  }

}

public showError(text: string, duration: number = 3000){
  let toast = this.toastCtrl.create({
    message: text,
    position: 'top',
    cssClass: 'toast-error',
    duration: duration
  });
  toast.present();         
}
public showMessage(text: string, duration:number = 3000){
  this.showError(text,duration);
}


public wc_hex_is_light(color) {
  const hex = color.replace('#', '');
  const c_r = parseInt(hex.substr(0, 2), 16);
  const c_g = parseInt(hex.substr(2, 2), 16);
  const c_b = parseInt(hex.substr(4, 2), 16);
  const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
  return brightness > 155;
}

public invertcolor(color){
  if(this.wc_hex_is_light(color)){
    return "#000000";
  }
  else{
    return "#ffffff";
  }  
}


openModal(title:string, text:string, buttons:any[]) {
  return new Promise(resolve => {
    const gModal = this.modalCtrl.create(GenericModalPage, { title: title, message: text, buttons:JSON.stringify(buttons) }, { enableBackdropDismiss: false, cssClass:'genericModal' });
    gModal.onDidDismiss(data => {
      resolve(data);
    });
    
    gModal.present();
  
  });

  
  
}



}



// WEBPACK FOOTER //
// ./src/providers/common-data.ts